import Vue from 'vue';
import buildFormParams from '../mixins/formParamBuilder';
import dateFormatter from '../mixins/dateFormatter';
import ContactEditGroupMembershipsTable from '../components/tables/ContactEditGroupMembershipsTable';
import ContactEditCatchlightTable from '../components/tables/ContactEditCatchlightTable';
import ContactEditCampaignSubscriptionsTable from '../components/tables/ContactEditCampaignSubscriptionsTable';
import ContactEditContactActivitiesTable from '../components/tables/ContactEditContactActivitiesTable';
import ContactEnrichButton from '../components/contact/enrich/ContactEnrichButton.vue';
import Modal from '../components/Modal';
import ActionModal from '../components/ActionModal';
import swal from 'sweetalert2';
import {updateContact} from '../utility/api/contact/updateContact';
import * as Sentry from "@sentry/vue";
import {getEnvironmentVars} from "../utility/api/open/getEnvironmentVars";
import {getContact} from "../utility/api/contact/getContact";
import Echo from 'laravel-echo';

Vue.component('edit-contact', {
    components: {
        ContactEditCampaignSubscriptionsTable,
        ContactEditGroupMembershipsTable,
        ContactEditCatchlightTable,
        ContactEditContactActivitiesTable,
        ContactEnrichButton,
        Modal,
        ActionModal,
    },
    mixins: [dateFormatter, buildFormParams],
    data() {
        return {
            contact: JSON.parse(this.vueContact),
            groups: JSON.parse(this.vueGroups),
            contactActivity: JSON.parse(this.vueContactActivity),
            activityMeta: {},
            showModal: false,
            requestProcessing: false,
            subscribeToGroupId: JSON.parse(this.vueSubscribeToGroupId),
            subscribeToCampaignId: JSON.parse(this.vueSubscribeToCampaignId),
            group: JSON.parse(this.vueGroup),
            brainErrors: {
                uniqueEmail: null,
            },
        };
    },
    methods: {
        handleRequest() {
            let self = this;

            this.$validator
                .validateAll()
                .then(isValid => {
                    if (isValid) {
                        this.requestProcessing = true;
                        let formParams = this.buildFormParams('contactEditForm', true, false);
                        formParams.campaignsToSubscribeTo = this.campaignsToSubscribeTo;
                        document.getElementById('saveButton').disabled = true;

                        updateContact(formParams)
                            .then(() => {
                                $.notify('Saved!', 'success');

                                //edit existing contact
                                if (!!self.contact) {
                                    //edit an existing contact redirect
                                    location.reload();
                                }
                                //create new contact to subscribe to campaign redirect
                                else if (!!self.subscribeToCampaignId) {
                                    window.location =
                                        '/inventory/campaigns/subscribers/?sk_token=' + btoa('campaign_id=' + self.subscribeToCampaignId);
                                } else if (!!self.subscribeToGroupId) {
                                    //create and subscribe contact to group
                                    window.location =
                                        '/inventory/contacts/groups/edit/?sk_token=' + btoa('group_id=' + self.subscribeToGroupId);
                                } else {
                                    //create a new contact redirect
                                    window.location = '/inventory/contacts';
                                }
                            })
                            .catch(error => {
                                if (error && error.response && error.response.data) {
                                    const {errors} = error.response.data;
                                    const errorTypes = Object.keys(errors || {});

                                    if (errorTypes.includes('email')) {
                                        this.brainErrors.uniqueEmail = 'You already have a contact with this email address.';
                                    }

                                    this.requestProcessing = false;
                                    document.getElementById('saveButton').disabled = false;
                                    $.notify('Please correct errors!', 'warning');
                                } else {
                                    Sentry.captureException(error);
                                    swal.fire({
                                        title: 'Uh Oh!',
                                        text: 'We had a problem saving your info.',
                                        type: 'error',
                                        confirmButtonText: 'Ok',
                                        buttonsStyling: false,
                                        confirmButtonClass: 'btn btn-lg btn-primary',
                                    });
                                }
                            });
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        encode(key, val) {
            return btoa(key + '=' + val);
        },
        initializePusher(environmentVars) {
            const self = this;
            const {pusherKey} = environmentVars;

            if (self.contact) {
                new Echo({
                    broadcaster: 'pusher',
                    key: pusherKey,
                    cluster: 'us2',
                    forceTLS: true,
                    authEndpoint: '/api/?entity=broadcasting&action=getBroadcastingAuth',
                })
                    .private('contact.' + self.contact.id)
                    .listen('.notification', function(data) {
                        self.$root.$emit('add-notification', data);
                        self.$root.$emit('enrichment-complete', data);

                        getContact(self.vesselId, self.contact.id).then(function (response) {
                            self.contact = response.data.data;
                        });
                    });
            }
        }
    },
    props: [
        'vesselId',
        'vueContact',
        'vueGroup',
        'vueGroups',
        'vueContactActivity',
        'vueSubscribeToCampaignId',
        'vueSubscribeToGroupId',
    ],
    computed: {
        globallyUnsubscribed() {
            return JSON.parse(this.vueContact || '{}').global_unsubscribe;
        },
    },
    mounted() {
        getEnvironmentVars().then(environmentVars => {
            this.initializePusher(environmentVars);
        });
    }
});
